"use client";

import { c as _c } from "react/compiler-runtime";
import { Brain } from "lucide-react";
import type { ClassicQuizParticipation } from "./types";
interface QuizCardProps {
  quiz: ClassicQuizParticipation;
  labels: Record<string, string>;
}
export default function QuizCard(t0) {
  const $ = _c(25);
  const {
    quiz,
    labels
  } = t0;
  const title = quiz.classicQuizModel?.title || quiz.classicQuizId;
  const scoreText = `${quiz.correct}/${quiz.classicQuizQuestions}`;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Brain className="h-2.5 w-2.5" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = labels.gameTypeQuiz || "Quiz";
  let t3;
  if ($[1] !== t2) {
    t3 = <span className="inline-flex items-center gap-1 rounded-full bg-violet-500/10 px-1.5 py-0.5 text-[10px] font-semibold text-violet-600">{t1}{t2}</span>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== quiz.points) {
    t4 = quiz.points > 0 && <span className="text-xs font-bold text-primary">+{quiz.points} pts</span>;
    $[3] = quiz.points;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <div className="flex items-center justify-between">{t3}{t4}</div>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== title) {
    t6 = <p className="text-sm font-medium text-foreground line-clamp-2">{title}</p>;
    $[8] = title;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = labels.score || "Score";
  let t8;
  if ($[10] !== scoreText) {
    t8 = <span className="font-semibold text-foreground">{scoreText}</span>;
    $[10] = scoreText;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <span>{t7}: {t8}</span>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== labels.attempts || $[16] !== quiz.attempts) {
    t10 = quiz.attempts > 1 && <span>{quiz.attempts} {labels.attempts || "attempts"}</span>;
    $[15] = labels.attempts;
    $[16] = quiz.attempts;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div className="flex items-center justify-between text-xs text-muted-foreground">{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t5 || $[23] !== t6) {
    t12 = <div className="flex flex-col gap-2 rounded-lg bg-card p-3">{t5}{t6}{t11}</div>;
    $[21] = t11;
    $[22] = t5;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
}